import AGENCY_LIST from "./agencies/agency-list";

export const MOCKED_AGENCIES_STATE = {
  agencies: AGENCY_LIST
};
